import React from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@outpave/ds";

interface CardNicknameFieldProps {
  nickname: string;
  onNicknameChange: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  >;
  onNicknameClear: () => void;
}

const CardNicknameField: React.FC<CardNicknameFieldProps> = ({
  nickname,
  onNicknameChange,
  onNicknameClear,
}) => {
  const { t } = useTranslation();
  return (
    <TextField
      label={t("Card Nickname")}
      name="nickname"
      fullWidth
      placeholder={t("Nickname your card") as string}
      value={nickname}
      onChange={onNicknameChange}
      onClear={onNicknameClear}
    />
  );
};

export default CardNicknameField;
